import React, { Component } from 'react';
import { Fragment } from 'react';
import moment from 'moment';
import i18n from 'utils/translate';
import Section from 'components/Section';
import ConfirmationField from 'components/ConfirmationField';

class PersonalDataConfirmation extends Component {
  render() {
    const {
      anrede,
      vorname,
      nachname,
      geburtsdatum,
      strasse,
      nr,
      plz,
      ort,
      land = i18n('Österreich'),
      telefon,
      email
    } = this.props;

    return (
      <Fragment>
        {/* --- Personal Data --- */}
        <Section header={i18n('Persönliche Angaben')}>
          <ConfirmationField title={i18n('Name')}>{`${
            anrede === 0 ? i18n('Herr') : i18n('Frau')
          } ${vorname} ${nachname}`}</ConfirmationField>
          <ConfirmationField title={i18n('Geburtsdatum')}>
            {moment(geburtsdatum).format('DD.MM.YYYY')}
          </ConfirmationField>
        </Section>

        {/* --- Address --- */}
        <Section header={i18n('Wohnadresse')}>
          <ConfirmationField title={null}>{`${strasse} ${nr}`}</ConfirmationField>
          <ConfirmationField title={null}>{`${plz} ${ort}`}</ConfirmationField>
          <ConfirmationField title={null}>{`${land}`}</ConfirmationField>
        </Section>

        {/* --- Contact --- */}
        <Section header={i18n('Kontakt')}>
          <ConfirmationField title={i18n('Telefon')}>{telefon}</ConfirmationField>
          <ConfirmationField title={i18n('E-Mail')}>{email}</ConfirmationField>
        </Section>
      </Fragment>
    );
  }
}

export default PersonalDataConfirmation;
